import { BillTypeCreate } from './BillTypeCreate'
import { BillTypeEdit } from './BillTypeEdit'
import { BillTypeList } from './BillTypeList'
import Icon from "@material-ui/icons/NoteAdd";
export default {
  list: BillTypeList,
  create: BillTypeCreate,
  edit: BillTypeEdit,
  icon: Icon
}


// WEBPACK FOOTER //
// ./src/components/billtype/index.js